<template>
  <div :modelValue="modelValue" v-bind="$attrs" style="width: auto; min-width: 90px">
    <label>
      <v-text-field
        style="font-size: 12px"
        class="mytextfield ma-0 pa-0"
        :class="IF.MyFont"
        maxlength="20"
        :modelValue="getValue()"
        @change="handleInput($event.target.value)"
        @click:clear="handleInput('')"
        :label="label"
        density="compact"
        hide-details
        :clearable="clearable"
        :append-inner-icon="appendInnerIcon"
      >
      </v-text-field>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array,
      default: () => [null, null],
    },
    appendInnerIcon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: Number.MIN_VALUE,
    },
    max: {
      type: Number,
      default: Number.MAX_VALUE,
    },
  },
  data() {
    return {
      numbers: this.modelValue,
    };
  },
  methods: {
    getValue() {
      var str = "";
      if (this.numbers[0] != null && this.numbers[0] != "") {
        str += this.numbers[0];
      }
      if (this.numbers[1] != null && this.numbers[1] != "") {
        str += "-" + this.numbers[1];
      }
      return str;
    },
    handleInput(val) {
      var sp = val.split("-", 2);
      if (sp.length == 1) {
        sp.length = 2;
        sp[1] = sp[0];
      }
      var n1 = Number(sp[0]);
      var n2 = Number(sp[1]);
      if (!isNaN(n1) && !isNaN(n2) && sp[0] != "" && sp[1] != "") {
        if (n1 > n2) {
          this.numbers = [n2, n1];
        } else {
          this.numbers = [n1, n2];
        }
      } else {
        this.numbers = [null, null];
      }

      this.$emit("change", [...this.numbers]);
      this.$emit("input", [...this.numbers]);
      this.$emit("update:modelValue", [...this.numbers]);
    },
  },
};
</script>

<style>
</style>